import classes from "./formCheckBoxChip.module.css";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";

export const FormCheckboxChips = ({
  id,
  label,
  options = [],
  register,
  watch,
  setValue,
  value: standaloneValue,
  onChange,
  disabled,
  validation = {},
  error,
  required = false,
  floatingLabel = false,   // ✅ NEW PROP
}) => {
  const value = watch ? watch(id) : standaloneValue;

  const isArray = Array.isArray(value);
  const hasValue = value !== null && value !== undefined;
  const selectedValues = isArray ? value : hasValue ? [value] : [];

  const hasSelection = selectedValues.length > 0;

  const handleClick = (opt) => {
    if (disabled) return;

    let newValue;

    if (isArray) {
      newValue = selectedValues.includes(opt.id)
        ? selectedValues.filter((v) => v !== opt.id)
        : [...selectedValues, opt.id];
    } else {
      newValue = value === opt.id ? null : opt.id;
    }

    if (watch && setValue) {
      setValue(id, newValue, { shouldValidate: true });
    } else if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <div
      className={`
        ${classes.container}
        ${error ? classes.error : ""}
        ${disabled ? classes.disabled : ""}
        ${hasSelection ? classes.selected : ""}
        ${floatingLabel ? classes.floating : ""}
      `}
    >
      {label && (
        <span
          className={`
            ${classes.label}
            ${floatingLabel && hasSelection ? classes.labelFloat : ""}
            ${error ? classes.labelError : ""}
          `}
        >
          {label}
          {required && <span className={classes.asterisk}>*</span>}
        </span>
      )}

      <div className={classes.chipsWrapper}>
        {options.map((opt) => {
          const isActive = selectedValues.includes(opt.id);

          return (
            <span
              key={opt.id}
              className={`${classes.chip} ${
                isActive ? classes.active : ""
              } ${disabled ? classes.disabled : ""}`}
              onClick={() => handleClick(opt)}
            >
              {opt.label}
            </span>
          );
        })}
      </div>

      {register && <input type="hidden" {...register(id, validation)} />}

      {error && typeof error === "string" && (
        <div className={classes.errorIcon} title={error}>
          <ExclamationCircleIcon className={classes.icon} />
        </div>
      )}
    </div>
  );
};